<!-- 组件说明 -->
<template>
  <div class="container" ref="container">
    <div class="pro-left">
      <!-- 大图 -->
      <!-- 单品 -->
      <div
        class="t promo_img"
        @mouseover="showBigImg"
        @mousemove="handleMove"
        @mouseout="hideBigImg"
        ref="promo_img"
        v-if="goodsType == 1"
      >
        <img
          v-if="getImages"
          v-lazy="
            img.large
              ? img.large
              : getImages[0].large
              ? getImages[0].large
              : $defaultImg
          "
          alt=""
          class="pic"
        />
        <div class="mask" v-show="isShowMask" ref="mask"></div>
        <div class="big" v-if="isShowBig" ref="big">
          <img
            v-if="getImages"
            v-lazy="
              img.source
                ? img.source
                : getImages[0].source
                ? getImages[0].source
                : $defaultImg
            "
            alt=""
            class="bigImg"
            ref="bigImg"
          />
        </div>
      </div>
      <!-- 套餐 -->
      <div
        class="t promo_img"
        @mouseover="showBigImg"
        @mousemove="handleMove"
        @mouseout="hideBigImg"
        ref="promo_img"
        v-else
      >
        <img
          v-lazy="gooodsDetail.image ? gooodsDetail.image : $defaultImg"
          alt=""
          class="pic"
        />
        <div class="mask" v-show="isShowMask" ref="mask"></div>
        <div class="big" v-show="isShowBig" ref="big">
          <img
            v-lazy="gooodsDetail.image ? gooodsDetail.image : $defaultImg"
            alt=""
            class="bigImg"
            ref="bigImg"
          />
        </div>
      </div>
      <!-- 小图 -->
      <!-- 单品 -->
      <div class="b-container" v-if="goodsType == 1">
        <div
          class="b"
          :style="`width:${getWidth}px;margin-left:${marginLeft}px;`"
        >
          <div
            class="b-item  c-pointer"
            v-for="(item, index) in getImages"
            :key="index"
            @mouseover="changeImg(item)"
          >
            <img v-lazy="item.small ? item.small : $defaultImg" alt="img" />
          </div>
        </div>
        <div class="preBtn el-icon-arrow-left" @click="pre"></div>
        <div class="nextBtn el-icon-arrow-right" @click="next"></div>
      </div>
      <!-- 套餐 -->
      <div class="b-container " v-else>
        <div class="b">
          <div class="b-item  c-pointer">
            <img
              v-lazy="gooodsDetail.image ? gooodsDetail.image : $defaultImg"
              alt="img"
            />
          </div>
        </div>
        <div class="preBtn el-icon-arrow-left" @click="pre"></div>
        <div class="nextBtn el-icon-arrow-right" @click="next"></div>
      </div>
    </div>

    <div v-if="goodsType == 1">
      <div class="collect" @click="handleCollect(gooodsDetail.id)">
        <div class="c-pointer" v-if="!gooodsDetail.isFavorite">
          <img :src="require('@/assets/images/icon_collection.png')" alt="" />
          <span>收藏该商品</span>
        </div>
        <div class="c-pointer" v-else>
          <img :src="require('@/assets/images/icon_collection2.png')" alt="" />
          <span>已收藏</span>
        </div>
      </div>
    </div>
    <p class="notice">
      温馨提示：图片均为本公司对原品的真实拍摄，仅供参考：如果新包装上市可能存在上新滞后，请以实物为准。
    </p>
  </div>
</template>

<script>
//import x from ''
export default {
  components: {},
  props: ["gooodsDetail", "goodsType"],
  data() {
    return {
      isCollect: false, //是否收藏
      isShowMask: false, //是否显示遮罩层
      isShowBig: false, //是否显示大图
      img: {},
      num: 0,
      marginLeft: "",
      w: ""
    };
  },
  watch: {
    $route: function(t, f) {
      this.img = {};
    }
  },

  created() {
  },
  computed: {
    getWidth() {
      if (this.getImages) {
        return this.getImages.length * (72 + 10) - 10;
      }
    },
    getImages() {
      const { images, image } = this.gooodsDetail;
      return images.length
        ? images
        : [{ large: image, source: image, small: image }];
    }
  },
  methods: {
    next() {
      if (this.num < this.getImages.length - 5) {
        let w = this.getWidth / this.getImages.length;
        this.num++;
        this.marginLeft = -(this.num * w);
      }
    },
    pre() {
      if (this.num > 0) {
        let w = this.getWidth / this.getImages.length;
        this.num--;
        this.marginLeft = -(this.num * w);
      }
    },
    handleCollect(id) {
      if (this.gooodsDetail.isFavorite) {
        //取消收藏
        this.$api
          .POST_CANCELCOLLECT({
            goodsId: id
          })
          .then(res => {
            if (res.status) {
              this.gooodsDetail.isFavorite = false;
            }
          });
      } else {
        this.$api
          .POST_ADDCOLLECT({
            //添加收藏
            goodsId: id
          })
          .then(res => {
            if (res.status) {
              this.gooodsDetail.isFavorite = true;
            }
          });
      }
    },
    showBigImg() {
      this.isShowMask = true;
      this.isShowBig = true;
    },
    handleMove(e) {
      var x = e.pageX - this.$refs.container.offsetLeft;
      var y = e.pageY - this.$refs.container.offsetTop;
      var maskX = x - this.$refs.mask.offsetWidth / 2;
      var maskY = y - this.$refs.mask.offsetHeight / 2;
      var maskMax =
        this.$refs.promo_img.offsetWidth - this.$refs.mask.offsetWidth; //遮罩层最大的水平移动距离
      var maskMax_y =
        this.$refs.promo_img.offsetHeight - this.$refs.mask.offsetHeight; //遮罩层最大的竖直移动距离
      if (maskX <= 0) {
        maskX = 0;
      } else if (maskX >= maskMax) {
        maskX = maskMax;
      }
      if (maskY <= 0) {
        maskY = 0;
      } else if (maskY >= maskMax_y) {
        maskY = maskMax_y;
      }
      this.$refs.mask.style.left = maskX + "px";
      this.$refs.mask.style.top = maskY + "px";
      if (this.$refs.bigImg) {
        // 大图片的移动距离 = 遮挡层移动距离 * 大图片最大的移动距离 / 遮挡层的最大移动距离
        var bigMax = this.$refs.bigImg.offsetWidth - this.$refs.big.offsetWidth;
        var bigMax_y =
          this.$refs.bigImg.offsetHeight - this.$refs.big.offsetHeight;
        var bigX = (maskX * bigMax) / maskMax;
        var bigY = (maskY * bigMax_y) / maskMax_y;
        this.$refs.bigImg.style.left = -bigX + "px";
        this.$refs.bigImg.style.top = -bigY + "px";
      }
    },
    hideBigImg() {
      this.isShowMask = false;
      this.isShowBig = false;
    },
    changeImg(item) {
      this.img = item;
    }
  },
  mounted() {
    //  this.isCollectGoods();
  }
};
</script>

<style lang="scss" scoped>
/* 产品主图 */
.promo {
  height: 700px;
  border: 1px solid #999;
}

.pro-left .pic {
  width: 100%;
  height: 100%;
}
.mask {
  position: absolute;
  left: 0;
  top: 0;
  width: 300px;
  height: 300px;
  background-color: rgb(225, 225, 225);
  opacity: 0.3;
}
.big {
  position: absolute;
  left: 450px;
  top: 0;
  width: 500px;
  height: 500px;
  overflow: hidden;
  border: 1px solid #eeeeee;
  background: #ffffff;
}
.bigImg {
  position: absolute;
  top: 0;
  left: 0;
  width: 800px;
  height: 800px;
}
>>> .el-carousel__container {
  height: 72px;
  width: 410px;
}
.pro-left {
  width: 410px;
  position: relative;
  .t {
    width: 410px;
    height: 410px;
    margin: 0 0 12px 0;
    border: 1px solid #f5f5f5;
    > img {
      @include size(100%, 100%);
    }
  }
  .b {
    // display: flex;
    // justify-content: space-between;
    //  overflow-x: scroll;
    overflow: hidden;

    .b-item {
      width: 72px;
      height: 72px;
      border: 1px solid #f5f5f5;
      // flex-shrink: 0;
      margin-right: 10px;
      float: left;
      img {
        @include size(100%, 100%);
      }
    }
    .b-item:nth-last-child(1) {
      margin-right: 0px;
    }
  }
}
.collect {
  text-align: right;
  margin: 22px 0 0 0;
  img {
    vertical-align: middle;
  }
  span {
    color: #505050;
    font-size: 13px;
  }
}
.notice {
  font-size: 12px;
  color: #a6a6a6;
  margin-top: 18px;
}
.b-container {
  position: relative;
  overflow: hidden;
  &:hover {
    .preBtn,
    .nextBtn {
      display: block;
    }
  }
}
.preBtn {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 22px;
  height: 100%;
  font-size: 24px;
  background-color: black;
  opacity: 0.25;
  line-height: 70px;
  color: #ffffff;
  display: none;
  &:hover {
    opacity: 0.5;
  }
}
.nextBtn {
  position: absolute;
  right: 0 !important;
  top: 50%;
  transform: translateY(-50%);
  width: 22px;
  height: 100%;
  font-size: 24px;
  background-color: black;
  opacity: 0.25;
  line-height: 70px;
  color: #ffffff;
  display: none;
  &:hover {
    opacity: 0.5;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/main/detail/components/goods-img.vue